import { appConfiguration } from '@/store/configuration'
import { Translations } from '@/types/api/app-configuration'
import { get, isNumber } from 'lodash-es'
import { pluralize } from 'mega-composable'

function translate(path: string, options: { count: number | null }) {
  return getContent(appConfiguration.value?.translations, path, options)
}

function getContent(source: Translations | undefined, path: string, options: { count?: number | null } = { }) {
  const value = get(source, path)
  return isNumber(options.count) ? pluralize(value, options.count) : value
}

export { translate }
